import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import MarketPlaceBanner from '../../../asset/images/iStock-1194167566.jpg';

const PublisherBanner: React.FC = () => {
  return (
    <Box
      sx={{
        padding: '178px 15px 80px',
        backgroundImage: `url(${MarketPlaceBanner})`,
        backgroundSize: 'cover', // Ensure the image covers the entire area
        backgroundPosition: 'center', // Center the image
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        justifyContent: 'center', // Center the container horizontally
        alignItems: 'center', // Center the container vertically
        height: '100px',
      }}
    >
      <Grid container spacing={6} alignItems="center">
        <Grid sx={{ textAlign: 'center' }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '2.5rem' },
              mb: 2,
              lineHeight: 1.2,
              color: '#fff',
            }}
          >
            <span>Build And Share Your AI Agents</span>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '2.5rem' },
                mb: 2,
                lineHeight: 1.2,
                color: '#fff',
              }}
            ></Typography>
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 4,
              color: '#fff',
            }}
          >
            <span>Join thousands of developers creating intelligent agents that</span>
            <Typography
              variant="body1"
              sx={{
                mb: 2,
              }}
            >
              solve real problems
            </Typography>
          </Typography>

          <Stack direction="row" spacing={3} justifyContent="center">
            <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#fff', fontSize: '26px' }}>
              Become a Publisher
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PublisherBanner;
